const NOTICE_KEY = 'aspen_referral_notice';

/** Referral links carry a public code, never account or phone identifiers. */
export const referralFromUrl = (): string => {
  const code = new URLSearchParams(window.location.search).get('ref') || '';
  return /^[a-zA-Z0-9_-]{1,32}$/.test(code) ? code : '';
};

export const saveReferralNotice = (message: string) => {
  try { sessionStorage.setItem(NOTICE_KEY, message.slice(0, 500)); } catch { /* Login still succeeds. */ }
};

export const takeReferralNotice = (): string => {
  try {
    const message = sessionStorage.getItem(NOTICE_KEY) || '';
    return message;
  } catch { return ''; }
};

export const clearReferralNotice = () => {
  try { sessionStorage.removeItem(NOTICE_KEY); } catch { /* No stored notice. */ }
};
